module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_edit-03001a1f09041b34f1d35488f2be52a0.png";